import classnames from "classnames";
import { asField } from "informed";
import React, { Fragment } from "react";

export const TextArea = asField(({ fieldState, fieldApi, ...props }) => {
  const { value } = fieldState;

  const { setValue, setTouched } = fieldApi;
  const {
    field,
    onChange,
    onBlur,
    initialValue,
    // forwardedRef,
    className,
    content,
    ...rest
  } = props;
  return (
    <Fragment>
      <div className="form-group">
        {props.label && <label htmlFor={field}>{props.faClass && <i className={props.faClass}></i>}{props.label}</label>}
        {props.required && <i style={{ color: "red" }}>*</i>}
        <textarea
          {...rest}
          id={field}
          // ref={forwardedRef}
          rows={props.rows ? props.rows : 1}
          required={false}
          value={!value && value !== 0 ? "" : value}
          className={classnames(`form-control ${className}`, {
            "is-invalid": fieldState.error,
          })}
          onChange={(e) => {
            setValue(e.target.value);
            if (onChange) {
              onChange(e);
            }
          }}
          onBlur={(e) => {
            setTouched(true);
            if (onBlur) {
              onBlur(e);
            }
          }}
        />
        {props.helper && (
          <small className="form-text text-muted">{content}</small>
        )}
        {fieldState.error ? (
          <div className="invalid-field">{fieldState.error}</div>
        ) : null}
      </div>
    </Fragment>
  );
});
